export const TEST_STATUS = {
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete',
  TIMED_OUT: 'timed_out',
} as const;

export type TestStatus = (typeof TEST_STATUS)[keyof typeof TEST_STATUS];
